import React, { useState, useEffect, Fragment} from 'react';
import {
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  Table,
  TableBody,
  IconButton,
  TablePagination,
  Tooltip,
  makeStyles,
  Box
} from '@material-ui/core';
import { history } from './../../helpers'
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { tableCss } from './TableCss';
import { truncate } from '../../helpers';
import { useDispatch, useSelector } from 'react-redux';
import { manageUsersActions, walletActions, userFunctionActions } from "./../../actions";
import { TagPerfil } from "./../../components"
import { SkeletonUserTable } from "./../../components"
import { useTranslation } from 'react-i18next';

const useStyle = makeStyles(theme => ({
  actionsWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: 8,
  },
  actionsBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    width: "100%"
  }
}));

function UsersTable() {
  const dispatch = useDispatch();
  const { users, paging, loading, selectedUser } = useSelector(state => state.manageUsers)
  const { imagineLocals } = useSelector(state => state.domains)
  const classes = useStyle();
  const { t } = useTranslation();
  const columns = [
    { id: 'name', label: t('nome') },
    { id: 'area', label: t('area_de_atuacao') },
    { id: 'status', label: t('perfil_do_usuario') },
    { id: 'actions', label: '' },
  ];

  const tableClasses = tableCss({
    text: t('linhas_por_pagina'),
  });

  function handleChangePage(event) {
    let newPage = paging.page + 1;
    dispatch(
      manageUsersActions.getFilteredUsers(
        paging.search,
        newPage,
        paging.sort,
        paging.limit,
        paging.statusCode
      )
    );
  }

  function handleChangeRowsPerPage(event) {
    var limit = event.target.value || 10;
    dispatch(
      manageUsersActions.getFilteredUsers(
        paging.search,
        1,
        paging.sort,
        limit,
        paging.statusCode
      )
    );
  }

  function handleOpenDeleteUser(userId) {
    return () => {
      dispatch(manageUsersActions.toggleDialogDeleteUser(userId))
    }
  }

  function handleNavigate(userId, to) {
    return () => {
      if (selectedUser) {
        history.push(to)
      } else {
        dispatch(userFunctionActions.loadPage(userId, imagineLocals))
        history.push(to)
      }
    }
  }

  function handleNavigatePoints(userId, to) {
    return () => {
      dispatch(walletActions.getUserPointsRequestStart())
      if (selectedUser) {
        history.push(to)
      } else {
        dispatch(userFunctionActions.loadPage(userId, imagineLocals))
        history.push(to)
      }
    }
  }

  return (
    <Fragment>
      {loading ? (
      <SkeletonUserTable />
      ) : (
        <Paper className={tableClasses.paperRoot}>
          <TableContainer>
            <Table
              stickyHeader
              aria-label="users table"
              classes={{ root: tableClasses.table }}
            >
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      classes={{ root: tableClasses.tableCellHeader }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                { 
                  users.map(item => {
                    return (
                      <TableRow
                        hover
                        key={item.id}
                        style={{ cursor: 'pointer' }}
                        classes={{ root: tableClasses.tableRow }}
                      >
                        <TableCell
                          classes={{ root: tableClasses.tableCellRadiusLeft }}
                        >
                          {truncate(item.name, 30)}
                        </TableCell>
                        <TableCell classes={{ root: tableClasses.tableCell }}>
                          {item.occupationArea}
                        </TableCell>
                        <TableCell
                          className={tableClasses.oneLine}
                          classes={{ root: tableClasses.tableCell }}
                        >
                          <TagPerfil perfil={item.typeProfile.description} />
                        </TableCell>
                        <TableCell
                          classes={{ root: tableClasses.tableCellRadiusRight }}
                        >
                          <Box className={classes.actionsBox}>
                            <IconButton onClick={handleNavigatePoints(item.id, `/users/points/${item.id}`) }>
                              <Tooltip title="visualizar pontos" aria-label="visualizar pontos">
                                <VisibilityIcon />
                              </Tooltip>
                            </IconButton>
                            <IconButton onClick={handleNavigate(item.id, `/users/function/${item.id}`) }>
                              <Tooltip title="editar função" aria-label="editar função">
                                <EditIcon />
                              </Tooltip>
                            </IconButton>
                            <IconButton onClick={handleOpenDeleteUser(item.id)}>
                              <Tooltip title="excluir função" aria-label="excluir função">
                                <DeleteIcon />
                              </Tooltip>
                            </IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            component="div"
            classes={{
              input: tableClasses.paginationInput,
              spacer: tableClasses.paginationSpacer,
              caption: tableClasses.paginationCaption,
              toolbar: tableClasses.paginationToolbar,
            }}
            rowsPerPageOptions={[10, 20, 30, 40, 50]}
            count={paging.total}
            rowsPerPage={paging.limit}
            page={paging.page - 1}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            labelRowsPerPage={t('exibindo')}
          />
        </Paper>
      )}
    </Fragment>
  );
}

export { UsersTable };

